import * as React from 'react';
import { Upload as AntUpload } from 'antd';
import { UploadProps as AntUploadProps } from 'antd/lib/upload';
import { ProgressProps as AntProgressProps } from 'antd/lib/progress';

export type UploadProps = {
  children?: React.ReactNode;
  name?: string;
  listType: 'picture' | 'text' | 'picture-card';
  multiple: boolean;
  defaultFileList?: any[];
  progress?: AntProgressProps;
  disabled: boolean;
  className?: string;
  showUploadList: boolean;
  action?: string;
  beforeUpload?: (file: any, FileList: any) => boolean;
  onChange?: (info: any) => void;
};

const Upload = (props: UploadProps & AntUploadProps) => {
  return <AntUpload {...props} className="upload" />;
};

Upload.defaultProps = {
  listType: 'text',
  multiple: false,
  disabled: false,
  showUploadList: true,
};

export default Upload;
